// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1uMEK","resendInfoText":"OnGoingPaymentBox_resendInfoText__3Qqwz"};